import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import ScrollTop from "../ScrollTop.js";
// import SideBox from "../SideBox.js";
import Content from "../../components/ContentHeader.js";
import Route from "../../components/Route.js";

// css
import "../../css/News.css";
import "../../css/NewsPage.css";
import "../../css/Conference.css";

// img
import Cont07 from "../../assets/img/web_cont07.png";

function contents07() {
  return (
    <div className="webinar_wrap">
      <ScrollTop />

      {/* <SideBox /> */}

      {/* 페이지 타이틀명 설정 */}
      <Helmet>
        <title>레인보우브레인 | RPA+생성형AI 자동화 서비스 전문기업</title>
      </Helmet>
      <Content
        title="CONFERENCE"
        title1="콘텐츠를 통해 인사이트를 얻어보세요"
      />

      <Route route1="MEDIA" route2="CONFERENCE"></Route>

      <div className="contents_wrap content_bg">
        <div className="container">
          <div className="news_box">
            <div className="news_badge">
              <span>ONLINE</span>
            </div>

            <div className="news_content">
              <img src={Cont07} alt="이미지" />

              <div className="text_box">
                <p>
                  2023년에 하마터면 침체기예 빠질뻔한 CSP(Cloud Service
                  Provider)를 살리는 강력한 구원투수로 생성형 AI 모델이
                  등장했다. 2024년 역시 기업에서 복잡한 LLMOps를 지탱하기 위해
                  클라우드 서비스를 활용할 것으로 예상된다.
                  <br />
                  클라우드의 약점으로 언급되는 비용과 보안 문제는 시간이 지남에
                  따라 점차 개선될 것으로 보인다.
                </p>
              </div>
            </div>

            <div className="btn_webinar">공개예정</div>

            <div className="news_btn">
              <Link to="/media/Conference">
                <button className="btn_prev">목록</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default contents07;
